module.exports = __webpack_public_path__ + "static/media/data_info_alert_form.77c1f520.svg";